export default function CaprockMark({
  size = 64,
  tone = 'on-light',
}: {
  size?: number;
  tone?: 'on-light' | 'on-dark';
}) {
  return (
    <img
      src="/brand/caprock-mark.png"
      width={size}
      height={size}
      alt=""
      className="ln-auth-mark"
      style={{
        display: 'block',
        filter: tone === 'on-dark' ? 'invert(1)' : undefined,
      }}
    />
  );
}
